import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './OilGasSupplementalComponent.metadata.json5';
import GeneralSectorsComponent from '../subcomponents/GeneralSectors/GeneralSectorsComponent';
import GrossFeesforOilGasComponent from '../subcomponents/GrossFeesforOilGas/GrossFeesforOilGasComponent';
import OilandGasContractsComponent from '../subcomponents/OilandGasContracts/OilandGasContractsComponent';
import styles from '../ArchitectEngineer.module.scss';

function OilGasSupplementalComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OilGasSupplementalComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesFacTyp9: {
            visible: !_.isUndefined(modelVM.value.doeAppMakDecThaDirAff8) && modelVM.value.doeAppMakDecThaDirAff8
        },
        ifYesPleProDetExp13: {
            visible: !_.isUndefined(modelVM.value.areSerProNotUndAWri12) && modelVM.value.areSerProNotUndAWri12
        },
        ifYesPleProDetExp15: {
            visible: !_.isUndefined(modelVM.value.doeYouComOrAnyRelCom14) && modelVM.value.doeYouComOrAnyRelCom14
        },
        whaIsYouAveOilGasCon18: {
            defaultValue: { amount: 0, currency: 'cad' }
        },
        whaIsYouLarConVal19: {
            defaultValue: { amount: 0, currency: 'cad' }
        },
        ifYesPleProDetExp7: {
            visible: !_.isUndefined(modelVM.value.doTheActAsARepFor6) && modelVM.value.doTheActAsARepFor6 === true
        },
        generalSectorsComponent: {
            data: modelVM.generalSectorsDTO,
            updateWizardData,
            submissionVM,
            GeneralSectorsPath: `${pathUpdated}.generalSectorsDTO`
        },
        grossFeesforOilGasComponent: {
            data: modelVM.grossFeesforOilGasDTO,
            updateWizardData,
            submissionVM,
            GrossFeesforOilGasPath: `${pathUpdated}.grossFeesforOilGasDTO`
        },
        oilandGasContractsComponent: {
            data: modelVM.oilandGasContractsDTO,
            updateWizardData,
            submissionVM,
            OilandGasContractsPath: `${pathUpdated}.oilandGasContractsDTO`
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            generalSectorsComponent: GeneralSectorsComponent,
            grossFeesforOilGasComponent: GrossFeesforOilGasComponent,
            oilandGasContractsComponent: OilandGasContractsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {

            if(changedPath === 'whaIsYouAveOilGasCon18' || changedPath === 'whaIsYouLarConVal19') {
                if (!_.isUndefined(value) && (value?.amount === '-' || value?.amount < 0)) return;
            }
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OilGasSupplementalComponent.propTypes = wizardProps;
export default withRouter(OilGasSupplementalComponent);
